import { Component } from "solid-js";

interface EmergingBrandsIconProps {
  class?: string;
}

export const EmergingBrandsIcon: Component<EmergingBrandsIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.66 17.9533L6.25333 20.0386L6.59733 22.6346C6.788 24.0746 7.92 25.208 9.36 25.4L11.9627 25.748L14.0467 27.34C15.2 28.2213 16.7987 28.2213 17.952 27.34L20.0373 25.7466H20.0347L22.632 25.4026C24.072 25.212 25.2053 24.08 25.3973 22.64L25.744 20.0373C25.744 20.0386 26.5493 18.984 27.3373 17.9533C28.2187 16.8 28.2173 15.2013 27.3373 14.048L25.7467 11.9613L25.4027 9.3653C25.212 7.9253 24.08 6.79197 22.64 6.59997L20.036 6.2533L17.952 4.66131C16.7987 3.77997 15.2 3.77997 14.0467 4.66131L11.9613 6.2533H11.964L9.36667 6.59864C7.92667 6.78931 6.79333 7.9213 6.60133 9.3613L6.25333 11.964C6.25333 11.9626 5.448 13.0173 4.66 14.048C3.78 15.2 3.78 16.8 4.66 17.9533V17.9533Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.4014 20.5453L15.508 19.964C15.816 19.8026 16.184 19.8026 16.492 19.964L17.5987 20.5453C17.956 20.7333 18.3867 20.7013 18.712 20.464L19.1254 20.164C19.4507 19.928 19.6134 19.5266 19.5467 19.1306L19.3347 17.8986C19.276 17.556 19.3894 17.2053 19.6387 16.9626L20.5334 16.0906C20.8214 15.8093 20.9254 15.3893 20.8014 15.0066L20.644 14.5213C20.52 14.1386 20.1894 13.86 19.7907 13.8013L18.5534 13.6213C18.2094 13.572 17.912 13.3546 17.7574 13.0426L17.204 11.9213C17.0254 11.5613 16.6574 11.3333 16.2547 11.3333H15.744C15.3414 11.3333 14.9734 11.5613 14.796 11.9226L14.2427 13.044C14.088 13.356 13.7907 13.5733 13.4467 13.6226L12.2094 13.8026C11.8107 13.8613 11.48 14.14 11.356 14.5226L11.1987 15.008C11.0747 15.3906 11.1774 15.8106 11.4667 16.092L12.3614 16.964C12.6107 17.2066 12.724 17.5573 12.6654 17.9L12.4534 19.132C12.3854 19.5293 12.5494 19.9293 12.8747 20.1653L13.288 20.4653C13.6134 20.7 14.0454 20.732 14.4014 20.5453V20.5453Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
